import { createRoute } from '@tanstack/react-router';
import { appRoute } from './parent-routes';
import PlaceholderPage from '@phrmpc/shared/components/PlaceholderPage';

const memberManagementRoute = createRoute({
  getParentRoute: () => appRoute,
  path: 'member-management',
  staticData: {
    handle: { title: 'Member Management' },
  },
});

const memberRecordsRoute = createRoute({
  getParentRoute: () => memberManagementRoute,
  path: 'member-records',
  component: () => <PlaceholderPage title="Member Records" />,
  staticData: {
    handle: { title: 'Member Records' },
  },
});

const memberChangeRequestRoute = createRoute({
  getParentRoute: () => memberManagementRoute,
  path: 'change-request',
  component: () => <PlaceholderPage title="Member Record Change Request" />,
  staticData: {
    handle: { title: 'Member Record Change Request' },
  },
});

const memberManagementRouteTree = memberManagementRoute.addChildren([
  memberRecordsRoute,
  memberChangeRequestRoute,
]);

export default memberManagementRouteTree;
